<template>
  <div class="container">
    <div class="image" />
    <div class="content">订单已提交！</div>
    <div class="btn-group">
      <el-button round plain type="primary" @click="$router.push('/redeem-gift/gift-list')">继续兑换</el-button>
      <el-button round type="primary" @click="toOrder">查看订单</el-button>
    </div>
  </div>
</template>

<script>
import { service } from '@/utils/axios'
import store from '@/store'
export default {
  name: 'order-success',
  methods: {
    toOrder() {
      this.$router.push({ path: '/order-detail', query: { id: this.$route.query.id, isShowCkwl: true } })
    },
    async syncPoint() {
      // 兑换完更新首页
      const res = await service.get('/app/get_home_page')
      const info = res.data.data.user_info
      store.commit('user/SET_INFO', info)
    },
  },
  created() {
    this.syncPoint()
  },
}
</script>
<style lang="less" scoped>
.container {
  display: flex;
  align-items: center;
  flex-flow: column;
  .image {
    margin-top: 104px;
    width: 181px;
    height: 118px;
    background: url('../../../assets/images/order_success.png');
  }
  .content {
    margin-top: 37px;
    font-size: 24px;
    color: #333;
  }
  .btn-group {
    display: flex;
    margin-top: 25px;
  }
}
</style>
